import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Draggable from 'react-draggable';

function PaperComponent(props) {
  return (
    <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
      <Paper {...props} />
    </Draggable>
  );
}

const ToolboxScreenshotPopup = ({ screenshotData, handleClose }) => {
  const { id, username, screenshot, duration_in_secs } = screenshotData;

  const [countdown, setCountdown] = useState(duration_in_secs);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prevCountdown) => {
        if (prevCountdown === 1) {
          handleClose(id);
          return 0;
        }
        return prevCountdown - 1;
      });
    }, 1000);

    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Dialog
      open={true}
      onClose={(event, reason) => {
        if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
          handleClose(id);
        }
      }}
      disableEscapeKeyDown
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      PaperProps={{
        style: {
          backgroundColor: '#333333',
          color: 'white',
        },
      }}
    >
      <DialogTitle style={{ cursor: 'move', color: 'white' }} id="draggable-dialog-title">
        {username} <small style={{color: "tomato"}}>({countdown}s)</small>
        <IconButton
          aria-label="close"
          onClick={() => handleClose(id)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <img src={screenshot} alt={`Popup ${id}`} style={{ maxWidth: '100%' }} />
      </DialogContent>
    </Dialog>
  );
};

export default ToolboxScreenshotPopup;
